import React from "react";
import { Stores } from "Globals/Stores";
import { Box } from "@material-ui/core";

// App
import PropertyDetailsViewModel from "Globals/ViewModels/FormSections/PropertyDetails/PropertyDetailsViewModel";
import ApplicationFormViewModel from "Globals/ViewModels/ApplicationFormViewModel";
import { CustomInput } from "Globals/Styles/AppStyling";
import { CustomDatePicker } from "Globals/Views/CustomDatePicker";
import { Row } from "Globals/Styles/LayoutStyles";
import PersonViewModel from "Globals/ViewModels/Shared/PersonViewModel";
import { StyledAddButton } from "../PersonalDetailsFormView.styles";

interface IProps {
    viewModel: PersonViewModel;
    propertyDetailsViewModel: PropertyDetailsViewModel;
    applicationFormViewModel: ApplicationFormViewModel;
    storesContext: Stores;
}

export const PersonForm: React.FC<IProps> = ({ viewModel, propertyDetailsViewModel, applicationFormViewModel, storesContext }) => {
    const isDisabled = viewModel.IsDisabled(applicationFormViewModel, storesContext);

    return (
        <>
            <Row style={{ alignItems: "center" }}>
                <CustomInput label="Name" placeHolder="Enter their name" viewModel={viewModel} fieldName="name" shrink={true} inputProps={{ disabled: isDisabled }} />
                <CustomInput
                    type="select"
                    style={{ minWidth: "350px" }}
                    label="Gender"
                    placeHolder="Select their gender"
                    viewModel={viewModel}
                    fieldName="gender"
                    selectItems={storesContext.Domain.LookupStore.getGenderOptions}
                    inputProps={{ disabled: isDisabled }}
                />
                <CustomDatePicker
                    viewModel={viewModel}
                    label="Date of birth"
                    placeholder={"Enter date of birth"}
                    fieldName="dateOfBirth"
                    maxDate={new Date()}
                    value={viewModel.model.dateOfBirth}
                    onChange={(date) => {
                        propertyDetailsViewModel.restartTimer();
                        viewModel.setDate("dateOfBirth", date);
                    }}
                    resetCallback={propertyDetailsViewModel.restartTimer}
                    disabled={isDisabled}
                />
                <CustomInput
                    type="select"
                    style={{ minWidth: "350px" }}
                    placeHolder={"Please select"}
                    label="Relationship to you"
                    viewModel={viewModel}
                    fieldName="relationshipTypeId"
                    selectItems={storesContext.Domain.RelationshipTypeStore.getRelationshipTypeOptions}
                    inputProps={{ disabled: isDisabled }}
                />
            </Row>
            <Row style={{ alignItems: "center" }}>
                <CustomInput
                    multiLine={true}
                    fullwidth={true}
                    label="Please confirm why this person is not included in the purchase of the property"
                    placeHolder="Reasoning..."
                    viewModel={viewModel}
                    fieldName="notes"
                    inputProps={{ disabled: isDisabled }}
                />
                <Box style={{ display: "flex", alignItems: "start", marginTop: "22px" }}>
                    <StyledAddButton variant="contained" disableElevation onClick={() => viewModel.stash(propertyDetailsViewModel)} disabled={isDisabled}>
                        +
                    </StyledAddButton>
                </Box>
            </Row>
        </>
    );
};
